<div fxLayout="column" fxFlexFill>
  <div fxFlex>
    <ngx-ui-loader></ngx-ui-loader>
    <router-outlet class="hidden-router"></router-outlet>
  </div>
</div>
<!--<div class="wrapping-box-container">
  <div id="controls" class="controls">

    <button id="liveness-button" disabled (click)="onLivenessCheckPressed()" class="big-button">Liveness Check</button>
    <button id="enroll-button" disabled (click)="onEnrollUserPressed()" class="big-button">Enroll User</button>
    <button id="authenticate-button" disabled (click)="onAuthenticateUserPressed()" class="big-button">Authenticate User</button>
    <button id="id-scan-button" disabled (click)="onPhotoIDMatchPressed()" class="big-button">Photo ID Match</button>


    <p id="status">Initializing...</p>
  </div>
  <div id="custom-logo-container">
    <img class="facetec-logo" src="../assets/images/facetec_logo.png">
  </div>
</div>-->
